import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SafetyReportEditPage } from './safety-report-edit';
import { SharedModule } from '../../../shared/shared.module';
import { FoundationModule } from '../../../../_foundation/foundation.module';
import { PipesModule } from '../../../../pipes/pipes.module';
import { IonicSelectableModule } from 'ionic-selectable';

@NgModule({
  declarations: [
    SafetyReportEditPage,
  ],
    imports: [
        IonicPageModule.forChild(SafetyReportEditPage),
        SharedModule,
        FoundationModule,
        PipesModule,
        IonicSelectableModule,
    ],
})
export class SafetyReportEditPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/DPR Pages/safety/safety-report-edit/safety-report-edit.module.ts